module.exports = __webpack_public_path__ + "static/img/logo_tnp_dark.9051cd7e.svg";